import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  useMerchantApiMutation,
  useScrollToTopOnNewPage,
} from "../../../hooks";
import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export interface IOnboardingStep6Props extends IOnboardingStepProps {
  handleComplete: () => void;
}

export interface IOnboardingStep6ViewProps {
  isLoadingRequestAccountActivation: boolean;
  isSuccessRequestAccountActivation: boolean;
  handlePrevious: () => void;
  requestAccountActivation: () => void;
  handleComplete: () => void;
}

export const OnboardingStep6 = (props: IOnboardingStep6Props) => {
  useScrollToTopOnNewPage(true);

  // const queryClient = useQueryClient();
  // queryClient.invalidateQueries(["getOnboardingStatus"]);

  const {
    isLoading: isLoadingRequestAccountActivation,
    isSuccess: isSuccessRequestAccountActivation,
    // isError: isErrorRequestAccountActivation,
    // data: apiResponse,
    mutate: requestActivation,
  } = useMerchantApiMutation<null, null>("requestAccountActivation", [
    "getOnboardingStatus",
    "getAccountSettings",
  ]).usePostMutation;

  const requestAccountActivation = () => requestActivation(null);

  useEffect(() => {
    if (isSuccessRequestAccountActivation) {
      props.handleNext();
    }
  }, [isSuccessRequestAccountActivation]);

  return (
    <View
      isLoadingRequestAccountActivation={isLoadingRequestAccountActivation}
      isSuccessRequestAccountActivation={isSuccessRequestAccountActivation}
      requestAccountActivation={requestAccountActivation}
      {...props}
    />
  );
};
